var checkboxIndicator = 'fx_2d2fb1e5_1ygytkf0';

export { checkboxIndicator };
//# sourceMappingURL=indicator.vanilla.mjs.map
